"use strict";

var _Object$defineProperty = require("@babel/runtime-corejs3/core-js-stable/object/define-property");
var _interopRequireDefault = require("@babel/runtime-corejs3/helpers/interopRequireDefault");
_Object$defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
var _extends2 = _interopRequireDefault(require("@babel/runtime-corejs3/helpers/extends"));
var _react = _interopRequireDefault(require("react"));
var _ikon = _interopRequireDefault(require("./ikon"));
const Link = _ref => {
  let {
    title = 'Link',
    ...props
  } = _ref;
  return /*#__PURE__*/_react.default.createElement("svg", (0, _extends2.default)({}, props, {
    version: "1.1",
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 32 32"
  }), /*#__PURE__*/_react.default.createElement("title", null, title), /*#__PURE__*/_react.default.createElement("path", {
    d: "M12.625 25.5q0.219-0.25 0.469-0.344t0.594-0.094q0.313 0 0.609 0.094t0.578 0.344q0.469 0.5 0.469 1.063t-0.469 1.188l-1.375 1.25q-0.875 0.875-1.953 1.344t-2.297 0.469-2.281-0.469-1.969-1.344q-0.875-0.906-1.344-1.969t-0.469-2.219q0-1.281 0.453-2.359t1.359-1.953l0.734-0.75t1.625-1.641 1.641-1.625l0.75-0.734q1.125-1.094 2.25-1.703t2.313-0.734q1.219-0.156 2.219 0.188t1.906 1.188q0.219 0.219 0.359 0.5t0.141 0.625q0 0.313-0.125 0.609t-0.375 0.578q-0.563 0.5-1.125 0.5t-1.125-0.5q-0.781-0.813-1.859-0.531t-2.391 1.594l-4.688 4.688q-0.406 0.406-0.641 0.922t-0.234 1.141q0 0.594 0.219 1.078t0.656 0.859q0.406 0.406 0.891 0.641t1.109 0.234q0.594 0 1.078-0.234t0.922-0.641l0.688-0.625zM27 7.125q0.875 0.875 1.344 1.953t0.469 2.297-0.453 2.281-1.359 1.969l-5.063 5.063q-1.156 1.156-2.375 1.734t-2.438 0.578q-0.969 0-1.859-0.422t-1.703-1.203q-0.219-0.25-0.328-0.5t-0.109-0.563q0-0.344 0.094-0.625t0.344-0.563q0.219-0.188 0.5-0.313t0.625-0.125q0.313 0 0.594 0.125t0.531 0.313q0.781 0.781 1.766 0.594t2.109-1.344l0.797-0.781t1.734-1.719 1.734-1.719l0.797-0.781q0.469-0.438 0.703-0.938t0.234-1.063q0-0.625-0.234-1.125t-0.703-0.875q-0.375-0.438-0.797-0.672t-0.953-0.328q-0.5-0.094-1 0.078t-0.938 0.609l-1.625 1.563q-0.219 0.219-0.5 0.328t-0.625 0.109q-0.313 0-0.594-0.109t-0.531-0.328q-0.5-0.531-0.5-1.094t0.5-1.156l1.625-1.563q0.844-0.906 1.859-1.297t2.203-0.328q1.156 0.031 2.188 0.516t1.938 1.422v0z"
  }));
};
var _default = exports.default = (0, _ikon.default)(Link);
Link.__docgenInfo = {
  "description": "",
  "methods": [],
  "displayName": "Link",
  "props": {
    "title": {
      "defaultValue": {
        "value": "'Link'",
        "computed": false
      },
      "required": false
    }
  }
};